import { render, staticRenderFns } from "./SVGNoItem.vue?vue&type=template&id=2a045366&scoped=true&"
import script from "./SVGNoItem.vue?vue&type=script&lang=js&"
export * from "./SVGNoItem.vue?vue&type=script&lang=js&"
import style0 from "./SVGNoItem.vue?vue&type=style&index=0&id=2a045366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a045366",
  null
  
)

export default component.exports